
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { keepDecimal } from '@/utils/util'
import scroll from '@/mixins/scroll'
import { getGoodsInfo, getStoreLevelManageList, getPackagePriceList, getTerraceGoodsCategoryList } from '@/api/goodsModule'
import GoodsSwipe from './components/goodsSwipe.vue'

@Component({
  name: 'goodDetail',
  components: {GoodsSwipe}
})
export default class goodDetail extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string //合作方公司编号
  active = 0
  keepDecimal = keepDecimal

  tabList = [
    {
      name: '基本信息',
      id: 0
    },
    {
      name: '销售信息',
      id: 1
    },
    {
      name: '销售范围',
      id: 2
    },
    {
      name: '商品详情',
      id: 3
    },
  ]

  levelList: any = [
    {
      name: '普通用户',
      priceType: 1,
      priceTypeDesc: '阶梯定价',
      finnalPrice: '101起'
    },
    {
      name: '一级会员',
      priceType: 1,
      priceTypeDesc: '阶梯定价',
      finnalPrice: '101起'
    },
    {
      name: '二级会员',
      priceType: 2,
      priceTypeDesc: '折扣比例95%',
      finnalPrice: '95'
    },
    {
      name: '三级会员',
      priceType: 3,
      priceTypeDesc: '折扣金额 -15',
      finnalPrice: '85'
    },
  ]

  showPrice = false

  goodInfo: any = {} // 详情数据
  storeLevelManageList = []
  categoryOptions1All: Array<any> = []
  categoryOptions2All: Array<any> = []
  categoryOptions3All: Array<any> = []
  categoryOptions1: Array<any> = []
  categoryOptions2: Array<any> = []
  categoryOptions3: Array<any> = []
  categoryOptionsSearchAll: Array<any> = []
  category1Id: any = ''
  category2Id: any = ''
  category3Id: any = ''

  get categoryName () {
    let target1: any = null
    let target2: any = null
    let target3: any = null
    let name = ''
    if (this.category1Id) {
      target1 = this.categoryOptions1.find(i => i.categoryId === this.category1Id)
      if (target1) name = target1.categoryName
    }
    if (this.category2Id) {
      target2 = this.categoryOptions2.find(i => i.categoryId === this.category2Id)
      if (target2) name = `${name}-${target2.categoryName}`
    }
    if (this.category3Id) {
      target3 = this.categoryOptions3.find(i => i.categoryId === this.category3Id)
      if (target3) name = `${name}-${target3.categoryName}`
    }
    return name
  }

  getIsShow (item: any) {
    // @ts-ignore
    const targetItem = this.goodInfo.levelNotShowList.find(i => i.levelId === item.levelId)
    if (targetItem) return '否'
    return '是'
  }

  openData(item:any,index:any) {
    this.$set(this.levelList[index], 'isEdit', !item.isEdit)
  }

  openPrice (data: any) {
    getPackagePriceList({
      storeId: this.companyId,
      goodsId: this.$route.query.goodsId,
      packageId: data.packageId
    }).then(res => {
      this.levelList = this.storeLevelManageList.map((item: any) => {
        const copyItem: any = { ...item }
        copyItem.finalPriceCopy = Number(data.marketPrice) * item.buyDiscount
        copyItem.finalPrice = keepDecimal(Number(data.marketPrice) * item.buyDiscount, 2)
        copyItem.buyDiscount = (item.buyDiscount * 100).toFixed()
        copyItem.buyDiscountCopy = item.buyDiscount
        copyItem.buySubtract = ''
        copyItem.discountType = 1
        copyItem.buySubtractCopy = item.buySubtract
        return { ...copyItem }
      })
      res.data.forEach((item: any) => {
        let obj: any = this.levelList.find((ii: any) => ii.levelId === item.levelId)
        if (item.buyDiscount) {
          obj.finalPriceCopy = Number(data.marketPrice) * item.buyDiscount
          obj.finalPrice = keepDecimal(Number(data.marketPrice) * item.buyDiscount, 2)
          obj.buyDiscount = (item.buyDiscount * 100).toFixed()
          obj.buySubtract = ''
          this.$set(obj, 'discountType', 1) // 折扣比例
        }
        if (item.buySubtract) {
          obj.finalPriceCopy = ((Number(data.marketPrice) * 1000) - (item.buySubtract * 1000)) / 1000
          obj.finalPrice = keepDecimal(((Number(data.marketPrice) * 1000) - (item.buySubtract * 1000)) / 1000, 2)
          obj.buySubtract = item.buySubtract
          obj.buyDiscount = ''
          this.$set(obj, 'discountType', 2) // 折扣金额
        }
        obj.buyDiscountCopy = obj.buyDiscount
        obj.buySubtractCopy = obj.buySubtract
      })
      this.showPrice = true
      console.log('**************', data)
      console.log('this.levelList', this.levelList)
    })
  }

  closePrice() {
    this.levelList.forEach((item,index) => {
      this.$set(this.levelList[index], 'isEdit', false)
    })
    this.showPrice = false
  }

  // 获取客户分类数据
  getStoreLevelManageList () {
    const params = {
      storeId: this.companyId,
      isPage: 1,
      pageIndex: 1,
      pageSize: 1000
    }
    getStoreLevelManageList(params).then(res => {
      this.storeLevelManageList = res.data.records
    })
  }

  getCategoryTreeData () {
    return new Promise((resolve, reject) => {
      getTerraceGoodsCategoryList({ isPage: false, partnerCompanyId: this.partnerCompanyId }).then((res: any) => {
        resolve(res.data)
      })
    })
  }

  mounted () {
    Promise.all([this.getGoodsInfo(), this.getCategoryTreeData()]).then(res => {
      this.categoryOptions1All = []
      this.categoryOptions2All = []
      this.categoryOptions3All = []
      this.getCategory(res[1] as Array<any>)
      this.$nextTick(() => {
        this.categoryOptions1 = this.categoryOptions1All
        this.categoryOptionsSearchAll = []
        this.getCategoryOptionsSearchAll(res[1] as Array<any>)
        this.handleChange(this.goodInfo.terraceCategoryId)
      })
    })
    this.getStoreLevelManageList()
  }

  activated () {
    console.log('detail activited ***')
  }

  // 获取商品详情
  getGoodsInfo() {
    return new Promise((resolve, reject) => {
      getGoodsInfo({ goodsId:this.$route.query.goodsId, storeId: this.companyId }).then((res) => {
        this.goodInfo = { ...res.data }
        console.log('this.goodInfo ***', this.goodInfo)
        resolve(res.data)
      })
    })
  }

  // 处理导购标题数据
  detailData (arr:any) {
    let newArr = JSON.parse(JSON.stringify(arr))
    newArr = newArr.map((item)=> {
      return item.goodsTitle
    })
    return newArr.filter(Boolean).join(',')
  }

  @Watch('active')
  onActiveChange () {
    console.log('watch active ***', this.active)
  }

  getCategory (list: Array<any>) {
    list.forEach((item: any) => {
      let { children, ...obj } = item
      if (item.categoryLevel === 3) {
        this.categoryOptions3All.push(obj)
      } else if (item.categoryLevel === 2) {
        this.categoryOptions2All.push(obj)
      } else {
        this.categoryOptions1All.push(obj)
      }
      if (children) this.getCategory(children)
    })
  }

  getCategoryOptionsSearchAll (list: Array<any>) {
    list.forEach((item:any) => {
      let { children, ...obj } = item
      this.categoryOptionsSearchAll.push({ ...item })
      if (children) this.getCategoryOptionsSearchAll(children)
    })
  }

  handleChange (value: string) {
    let list = this.categoryOptionsSearchAll.filter((item: any) => item.categoryId === value)

    if (list.length === 0) {
      this.category1Id = undefined
      this.category2Id = undefined
      this.category3Id = undefined
      return false
    }
    let data = list[0].hierarchyId.split('.')

    if (data[0]) {
      this.category1Id = data[0]
      this.category2Id = undefined
      this.category3Id = undefined
      this.categoryOptions2 = this.filterData(this.categoryOptions2All, data[0])
      this.categoryOptions3 = []
    }

    if (data[1]) {
      this.category2Id = data[1]
      this.category3Id = undefined
      this.categoryOptions2 = this.filterData(this.categoryOptions2All, data[0])
      this.categoryOptions3 = this.filterData(this.categoryOptions3All, data[1])
    }
    if (data[2]) {
      this.category3Id = data[2]
      this.categoryOptions2 = this.filterData(this.categoryOptions2All, data[0])
      this.categoryOptions3 = this.filterData(this.categoryOptions3All, data[1])
    }
  }

  /**
   * @description 查找指定数据
   */
  filterData (list:Array<any>, parentId:string) {
    let categoryList = list.filter(item => item.parentId === parentId)
    return categoryList
  }
}
